export default __webpack_public_path__ + "static/media/logobuy.b39dfa47.png";